import { createReconnectingWebSocketInstance } from '@/setup/ws/WSConfig';
export function NotificationWS(url, id) {
  return createReconnectingWebSocketInstance(url, 'notifications', id);
}